import { useMemo } from "react"
import { createQuery } from "@nova/queryable"
import { useAircraftConditionStates } from "../aircraft/AircraftStatusQueries"
import { usePilotTrackingQuery } from "features/pilot-tracking/PilotTrackingQueries"

const conditionAircraftQuery = createQuery({
    resource: "aircraft",
    select: ["id", "manual_status"],
})

export type DroneConditionCounts = {
    total: number
    current: number
    upcoming: number
    overdue: number
}

export const useDroneConditionCounts = (): DroneConditionCounts => {
    const { data: aircraft } = usePilotTrackingQuery(conditionAircraftQuery)
    const states = useAircraftConditionStates(aircraft ?? [])

    return useMemo<DroneConditionCounts>(() => {
        if (!states) return { total: 0, current: 0, upcoming: 0, overdue: 0 }

        let current = 0
        let upcoming = 0
        let overdue = 0
        for (const state of Object.values(states)) {
            if (state === "overdue") overdue++
            else if (state === "upcoming") upcoming++
            else current++
        }

        const total = current + upcoming + overdue
        return { total, current, upcoming, overdue }
    }, [states])
}
